module.exports = __webpack_public_path__ + "static/media/logo-helper.05f8d751.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo-helper.png
// module id = 2139
// module chunks = 0